import React from 'react'
import '../App.css';
import { FiCommand } from "react-icons/fi";
import { Transition } from 'react-transition-group';
import { CenterFocusStrong } from '@material-ui/icons';

export default function WelcomePage({inProp, history, inRange, prevSchoolYear, schoolYear, prevApplicationDateRange, applicationDateRange, statusNotificationDate}) {
    const duration = 700;
    const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    }

    const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
    };

    if(inRange) {
        return (
            <>
            <Transition in={inProp} timeout={duration} appear>
                {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                <h1 className='Title-settings'>Welcome to the SD38 District Program Options Application</h1>
                <p>The online application for SD38 District Program Options (Early French Immersion, Late French Immersion and Montessori Programs) <b>is now closed</b> for the {prevSchoolYear} school Year.
                If you would like to submit a late application, please email <a href = "mailto: programoptions@sd38.bc.ca">programoptions@sd38.bc.ca</a> to obtain an application form which 
                can be filled out and returned by email. Please note that all late applications are placed at the bottom of the current waitlist.</p>
                <p>NOTE: For the {prevSchoolYear} school year, the online District Program Options Application period was open from {prevApplicationDateRange}.</p>
            </div>)}
            </Transition>
        </>   
        );
    } else {
        return (
            <>
            <Transition in={inProp} timeout={duration} appear>
                {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                <h1 className='Title-settings'>Welcome to the SD38 District Program Options Application</h1>
                <p>
                    This application is open from {applicationDateRange} for students registered in the Richmond School District to apply for 
                    the following programs for the {schoolYear} School Year.
                </p> <br/>
    
                <p className='details1'>
                    <b>Early French Immersion (EFI)</b><br/> Students entering Kindergarten or Grade 1 may apply <br/><br/>
                    <b>Montessori</b> <br/>Students entering Kindergarten and Grades 1-4 may apply <br/><br/>
                    <b>Late French Immersion (LFI)</b> <br/>Students entering Grade 6 may apply <br/><br/>
                </p>
                <p>
                    Please note: If you are applying to more than one program, you will need to complete an application for each program.
                </p>
                <p>
                    At the end of the application period, a draw will be held for available placements each District Program. 
                    Applicants will be advised of the status of their application on {statusNotificationDate}.
                </p>
                <p style={{textAlign: "center", color: "red", fontSize: "22px"}}>STOP! - Please Read Below</p>
                <p style={{fontSize: "15px"}}>
                    <u><b>Before you begin the application, please ensure you have the following information ready.</b></u>
                </p>
                <p>
                    1) Students new to SD38 for {schoolYear} will need to have completed an online registration form and have a Registration ID number. (If applying for twins or siblings, please ensure you have Registration ID numbers for both.)<br/>
                    OR<br/>
                    1) Current SD38 students will need to have their Pupil Number. This can be obtained by asking your current school office. (If applying for twins or siblings, please ensure you have Pupil Numbers for both.)
                </p>
                <p>
                2) If you have a sibling currently in a District Program and would like to qualify for sibling priority, you will need the sibling’s Pupil Number. 
                This can be obtained by asking the sibling’s current school office.
                </p>
                <p>
                    3) All applications will require basic contact information, including name, birthdate, residential address, phone number and email, for the student 
                    applicant and/or parent or legal guardian who is applying.
                </p>
                <p>
                    4) If you are a Non-Richmond resident, you will not be able to use this form. Please email <a href = "mailto: programoptions@sd38.bc.ca">programoptions@sd38.bc.ca</a> to inquire about applying.
                </p>
                <p>
                    Thank you for taking the time to complete the form. For more information about District Program Options, 
                    please visit <a href="https://www.sd38.bc.ca/programs/elementary-programs" target="_blank">https://www.sd38.bc.ca/programs/elementary-programs</a>
                </p>
            </div>)}
            </Transition>
        </>   
        );
    }
}